require('./SearchResults.scss');

const _ = {
    throttle: require('lodash/throttle'),
};
const b = require('app/www/libs/b')('search-results');

const React = require('react');
const PropTypes = require('prop-types');

const Link = require('app/www/components/blocks/Link/Link');

const SCROLL_TIMEOUT = 200;
const SCROLL_ACTIVATION_LENGTH = 0.6;

class SearchResults extends React.PureComponent {

    constructor(props) {
        super(props);

        this._page = 1;
        this._onScrollEventAdded = false;
        this._onScroll = _.throttle(this._onScroll.bind(this), SCROLL_TIMEOUT);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.loadOnScroll !== nextProps.loadOnScroll) {
            this._toggleScrollListener(nextProps.loadOnScroll);
        }
    }

    componentDidMount() {
        this._toggleScrollListener(this.props.loadOnScroll);
    }

    componentWillUnmount() {
        this._toggleScrollListener(false);
    }

    render() {
        const {
            items,
            title,
            total,
            isLoading,
            displayLimit,
            loadOnScroll,
            moreLinkText,
            ItemComponent,
            ItemPlaceholderComponent,
            onMoreLinkClick,
        } = this.props;

        let displayItems;
        let showMoreLink = false;

        if (!loadOnScroll) {
            displayItems = items.slice(0, displayLimit);
            showMoreLink = Boolean(moreLinkText) && total > displayLimit;
        } else {
            displayItems = items;
        }

        const linkProps = {
            url: null,
            onClick: onMoreLinkClick,
        };

        return (
            <div className={b()} ref={ref => (this._node = ref)}>
                <div className={b('title')}>{title}</div>
                {displayItems.map((item, index) => (
                    <ItemComponent key={item.id} {...item} index={index} />
                ))}
                {isLoading && (
                    <ItemPlaceholderComponent />
                )}
                {showMoreLink && (
                    <Link className={b('more-link')} {...linkProps}>{moreLinkText}</Link>
                )}
            </div>
        );
    }

    /**
     * @private
     */
    _onScroll() {
        const {total, items, isLoading, getSearchResults} = this.props;

        if (!isLoading && this._node) {
            const {innerHeight, pageYOffset} = window;
            const scrollOffset = innerHeight + pageYOffset;
            const tabBottom = this._node.offsetTop + this._node.offsetHeight;

            if (scrollOffset >= SCROLL_ACTIVATION_LENGTH * tabBottom) {
                if (items.length < total) {
                    this._page++;
                    getSearchResults(this._page);
                } else {
                    this._toggleScrollListener(false);
                }
            }
        }
    }

    /**
     * @private
     * @param {Boolean} loadOnScroll
     */
    _toggleScrollListener(loadOnScroll) {
        const {items, total} = this.props;

        if (loadOnScroll && items.length < total) {
            window.addEventListener('scroll', this._onScroll);
            this._onScrollEventAdded = true;
        } else if (this._onScrollEventAdded) {
            window.removeEventListener('scroll', this._onScroll);
        }
    }
}

SearchResults.defaultProps = {
    onMoreClick: () => {},
};

SearchResults.propTypes = {
    ItemComponent: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
    ]).isRequired,
    ItemPlaceholderComponent: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
    ]).isRequired,
    items: PropTypes.array.isRequired,
    displayLimit: PropTypes.number.isRequired,
    total: PropTypes.number,
    title: PropTypes.string.isRequired,
    moreLinkText: PropTypes.string,
    onMoreLinkClick: PropTypes.func,
    loadOnScroll: PropTypes.bool,
    getSearchResults: PropTypes.func,
};

module.exports = SearchResults;

